import { useState, useEffect } from "react";
import { HealthDashboard } from "health-dashboard";
import "health-dashboard/styles.css";
import { useGetCustomers } from "../../common/hooks/useGetCustomers";
import { useGetLocations } from "../../common/hooks/useGetLocations";
import { getJwtToken } from "../../common/utils/getJwtToken";
import { env } from "../../configs/reexports";

// Cube.js API URL - dynamically constructed based on environment
const CUBE_API_URL = `https://cube.${env.stacks.webapp.domain.apex}/cubejs-api/v1`;

export default function SystemHealthPage() {
  const { customers } = useGetCustomers();
  const { locations } = useGetLocations();
  const [cubeToken, setCubeToken] = useState<string>("");

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await getJwtToken();

        setCubeToken(token);
      } catch (error) {
        console.error("Failed to get auth token for Cube.js:", error);
      }
    };

    fetchToken();
  }, []);

  const filterOptions = {
    tenants:
      customers?.items?.map(customer => ({
        value: customer.id || "",
        label: customer.name || "",
      })) ?? [],

    facilities:
      locations?.items?.map(location => ({
        value: location.id || "",
        label: location.name || "",
      })) ?? [],
  };

  if (!cubeToken) {
    return <div>Loading...</div>;
  }

  return (
    <HealthDashboard
      cubeApiUrl={CUBE_API_URL}
      cubeApiToken={cubeToken}
      filterOptions={filterOptions}
    />
  );
}
